import { AppBar, Box, Toolbar, styled } from '@mui/material';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuthentication } from '../../context/AuthContext';
import GetRecords from '../../lib/api/GetRecords';
import { APIS } from '../../lib/constants/apis';
import { NACHRICHT_ORDNER } from '../../lib/constants/constant';
import { getFieldNamefromDataPath } from '../../utils/helper';
import DesktopHeader from './header-components/DesktopHeader';
import MobileHeader from './header-components/MobileHeader';

// import Schemas
import NachrichtSchema from '../../lib/paths/nachricht_FULL_Paths.json';
const P = NachrichtSchema.attributes;

export const StyledToolbar = styled(Toolbar)({
	display: 'flex',
	justifyContent: 'space-between',
});
export const NavLinksContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	[theme.breakpoints.up('lg')]: {
		position: 'absolute',
		left: '50%',
		transform: 'translateX(-50%)',
		maxWidth: 1140,
	},
}));
export const NavLinkStyled = styled(NavLink)(({ theme }) => ({
	padding: theme.spacing(2.2, 2),
	color: theme.palette.navbar.primary.main,
	textDecoration: 'none',
	borderBottom: `2px solid transparent`,
	'&.active': {
		color: theme.palette.navbar.primary.active,
		borderBottom: `2px solid ${theme.palette.navbar.primary.active}`,
	},
}));

function Header() {
	const location = useLocation();
	const { authenticatedData, isAuthenticated } = useAuthentication();
	const [unreadMessageCount, setUnreadMessageCount] = useState(0);

	useEffect(() => {
		const fetchNachricht = async () => {
			try {
				let fields = ['id'];
				let filterOption = {
					[getFieldNamefromDataPath(P.Antragsteller.path)]: { id: { $eq: get(authenticatedData, 'organisationId', -1) } },
					[getFieldNamefromDataPath(P.Allgemein_Ordner.path)]: NACHRICHT_ORDNER.Posteingang,
					[getFieldNamefromDataPath(P.Allgemein_gelesen.path)]: false,
				};
				let pagination = {
					start: 0,
					limit: 1,
					withCount: true,
				};
				let res = await GetRecords(APIS['Portal-Nachricht'], [], filterOption, [], pagination, fields);
				setUnreadMessageCount(get(res, 'meta.pagination.total', 0));
			} catch (err: any) {
				const errorData = JSON.parse(err.message);
				if (get(errorData, 'error.status') === 403 || get(errorData, 'error.status') === 401) {
					localStorage.removeItem('vdmk-token');
					window.location.reload();
				}
				console.error('ERROR: Fetching Nachrichten ', err);
			}
		};

		if (isAuthenticated) fetchNachricht();
	}, [authenticatedData, isAuthenticated, location]);

	if (isAuthenticated) {
		return (
			<>
				<AppBar position='sticky'>
					<Box sx={{ display: { xs: 'none', md: 'block' } }}>
						<DesktopHeader unreadMessageCount={unreadMessageCount} />
					</Box>
					<Box sx={{ display: { xs: 'block', md: 'none' } }}>
						<MobileHeader />
					</Box>
				</AppBar>
			</>
		);
	}
	return <></>;
}

export default Header;
